import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';


@Component({
    selector: 'app-simple-prompt',
    templateUrl: './simple-prompt.component.html',
    styleUrls: ['./simple-prompt.component.less']
})
export class SimplePromptComponent {

    public message = '';

    constructor(public dialogRef: MatDialogRef<SimplePromptComponent>,
                @Inject(MAT_DIALOG_DATA) public data: any) {
        this.message = data.message;
    }


    onNoClick(): void {
        this.dialogRef.close();
        this.message = '';
    }

}
